<template>
  <v-main class="fill-height">
    <v-container fluid class="fill-height d-flex flex-column align-center justify-center">
      <div>
        <v-img style="max-width: 300px" :src="require('@/assets/not-authorized.svg')" />
      </div>
      <div>
        <div class="text-center">
          <h1 class="font-bold">
            Não Autorizado!
          </h1>
          <p>Você não possui permissão para acessar está página.</p>
          <p>Use o botão <em>Voltar</em> abaixo.</p>
        </div>

        <div>
          <v-btn color="primary" block large @click="goToFeed">
            Voltar
          </v-btn>
        </div>
      </div>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'NotAuthorized',

  methods: {
    goToFeed() {
      this.$store.dispatch('company/resetCompany');
      this.$router
        .push({ name: 'dashboard' })
        .then(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
    },
  },
};
</script>
